import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import CheckinView from 'views/CheckInView';
import PATHS from 'lib/navigation/paths';
import generateHreflang from 'lib/utils/generateHreflang';

const CheckinPage = () => (
  <>
    <CheckinView />
  </>
);

export async function getServerSideProps(ctx) {
  const { locale } = ctx;
  const hreflangData = generateHreflang(PATHS.checkIn().url, ctx.locale);
  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'fe_er_check_in',
        'controllers',
        'fe_er_check_in',
      ])),
      hreflangData,
      options: {
        showCaptureEmailOverlay: false,
      },
    },
  };
}
export default CheckinPage;
